// tslint:disable:max-line-length
// tslint:disable:quotemark
// tslint:disable:whitespace
export const pcgSettingsDevelopment = {"mode":"Development","rollbarPostClientToken":"c1404ba8721747b989addc975509fda7"};
